import { useState } from '@wordpress/element';
import renderPost from './renderPost';

const GetResults = ({ cats, activeCats, search, posts }) => {

    let [display, setDisplay] = useState(9);
    let arr = []
    let first = 206;
    
    // console.log(posts);

    posts.forEach( (el, idx) => {
        if(el.categories.includes(first)){
            let featured = posts.splice(idx,1);
            arr.unshift(featured[0]);
        } else {
            arr.push(el);
        }
    })

    const sortedPosts = posts.sort((a, b) => {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        return bDate - aDate;
    });

    const loadMore = (e) => {
        e.preventDefault();
        setDisplay(display + 9);
    }

    return(
        <>
            <div className={`blog-grid__results`}>        
                {arr && arr.filter( post => {
                        if( search != null) {
                            return post.title.rendered.toLowerCase().includes(search);
                        }
                        return post;
                    }).filter( post => {
                        // console.log('y', post.categories);
                        if( activeCats === undefined || activeCats.length == 0 ) {
                            return post;
                        }
                        return activeCats.some(r=> post.categories.indexOf(r) >= 0);
                    }).map((filteredPost, idx) => (
                        idx < display ? renderPost(filteredPost, idx, cats) : null
                        // idx < display ? console.log(filteredPost) : null
                    ))
                } 
            </div>
            <div className={`blog-grid__results-more`}>
                { display < sortedPosts.length ? (
                    <button className={`button red-button`} onClick={ (e) => { loadMore( e ) } }>View More +</button>
                ) : (
                    <p>You've reached the end!</p>
                ) }
            </div>
        </>
    )
}

export default GetResults;